import { render, staticRenderFns } from "./RoleDetail.vue?vue&type=template&id=59ad3993&scoped=true&"
import script from "./RoleDetail.vue?vue&type=script&lang=js&"
export * from "./RoleDetail.vue?vue&type=script&lang=js&"
import style0 from "./RoleDetail.vue?vue&type=style&index=0&id=59ad3993&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ad3993",
  null
  
)

export default component.exports